import { render, staticRenderFns } from "./FooterStatements.vue?vue&type=template&id=4a2ba463&"
import script from "./FooterStatements.vue?vue&type=script&lang=js&"
export * from "./FooterStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports